module.exports = __webpack_public_path__ + "img/phone-alt-solid.fb02e9ef.svg";